<template>
  <validation-observer ref="Management">
    <div class="bg-gray p-2 mt-1">
      <div class="bg-white rounded p-3">
        <div class="row">
          <div class="col-md-12 text-bold bold mb-3">
            <i class=" fa fa-file-search color-orange" />
            Gestiones realizadas
          </div>
          <div class="col-md-12 mt-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.managementTypeId"
                :clearable="false"
                custom-error-msg="Favor seleccionar Tipo de Gestión."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de gestión:"
                :options="managementTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-12 mt-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="model.comment"
                :clearable="false"
                custom-error-msg="Favor escribir un comentario."
                :error="errors[0]"
                label="Comentario:"
                :maxlength="3000"
                show-char-count
                :count-classes="['d-block text-right']"
                :rows="4"
              />
            </validation-provider>
          </div>
          <custom-checkbox
           class="ml-3 mt-3 mb-3"
           text="Anejar Documento"
           v-model="showDocSection"
          />
          <div class="container-fluid" v-if="showDocSection">
            <div class="row box-container">
                <div class="col-12 col-md-4 mb-4 mb-md-0">
                  <label class="custom-file-input-label">Nombre de Documento:</label>
                  <validation-provider v-slot="{ errors }" :rules="showDocSection?'required':''">
                    <CustomInput
                      ref="personInChargeName"
                      type="text"
                      v-model="documentName"
                      class="mb-3 mt-md-0"
                      :error="errors[0]"
                      custom-error-msg="El nombre del documento es requerido"
                    />
                </validation-provider>
                </div>
                <div class="col-12 col-md-5 mb-4 mb-md-0">
                  <label class="custom-file-input-label">Archivo:</label>
                  <validation-provider  v-slot="{ errors }" name="document" :rules="showDocSection?'required':''">
                    <CustomFileInput
                      ref="fileUpload"
                      v-model="document"
                      display-style="normal"
                      :accept="'.pdf'"
                      :disabled="false"
                      required
                      :error="errors[0]"
                      :name ="document?.name"
                      custom-error-msg="Documento es Requerido"
                    />
                  </validation-provider>
                </div>
            </div>
          </div>
        </div>
          <div class="col-md-12 text-right mt-3 pt-1">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3"
              @click="$emit('on-close')"
            />
            <action-button
              i="fas fa-save"
              text="Guardar"
              variant="success"
              @click="submit"
            />
          </div>
        </div>
      </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import { addManagement } from '@/modules/compliance-rlv/api.js';
import ManagementResult from './ManagementResult';
import alertMixin from 'utils/mixins/alert.mixin';
import CustomFileInput from '@/components/common/CustomFileInput';
import objectToFormData from "object-to-formdata";
import CustomInput from 'CustomInput';
import { CustomCheckbox } from '@/components/common';
export default {
  name: 'Management',
  components: {
    CustomTextArea,
    CustomDropDown,
    ManagementResult,
    CustomFileInput,
    CustomInput,
    CustomCheckbox,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
    managementTypes: {
      type: Array,
      default: () => [],
    },
    stipulationType: {
      type: Number,
      default: 0,
    },
    studentSieId: {
      type: Number,
      default: 0,
    }
  },
  data: () => ({
    model: {
      Id: null,
      detailId: null,
      managementTypeId: null,
      comment: null,
      stipulationType: null
    },
    showDocSection:false,
    document: null,
    documentName: null,
    managementTypesData: [],
  }),
  methods: {
    async submit() {
      const isValid = await this.$refs.Management.validate();
      if (isValid) {
        this.model.detailId = this.id;
        let model = {
          Id: this.model.Id,
          ManagementTypeId: this.model.managementTypeId.id,
          Comment: this.model.comment,
          DetailId: this.model.detailId,
          DocumentName: this.documentName,
          StipulationType: this.stipulationType,
          StudentSieId: this.studentSieId,
        };
        const formData = objectToFormData(model, { indices: true });
        formData.append(`document`, this.document);
        addManagement(formData)
          .then(() => {
            this.ShowToast(
              'Confirmación',
              'La gestión ha sido documentada exitosamente.',
              'success'
            );
            this.model = {
              Id: null,
              detailId: null,
              managementTypeId: null,
              comment: null,
              stipulationType: null
            };
            this.document = null;
            this.documentName = null;
            this.showDocSection = false;
            this.$emit('on-close');
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
            this.$emit('on-close')
          });
      }
    },
  },
};
</script>
<style lang="scss"></style>
